import { useState, useEffect } from 'react'

const useDebounce = (value, delay = 500, callback) => {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(() => {
    const handler = setTimeout(() => {
      if (callback) {
        callback(value)
      }

      return setDebouncedValue(value)
    }, delay)

    return () => clearTimeout(handler)
  }, [value, delay])

  return debouncedValue
}

export default useDebounce
